import { _defineProperty } from "@slyte/core/src/lyte-utils";
import {Route} from "../../../node_modules/@slyte/router/index.js";
let TestingComp;

class Test extends Route {
    render() {
        return { outlet: '#zcatcomponent', component: TestingComp };
    }

    static actions(arg1) {
        return Object.assign(super.actions({

        }), arg1);
    }

    _() {
        _;
    }

    getRequirements() {
        arguments[1].push(import(
            /* webpackChunkName: "components/javascript/zcat-components/testing-comp" */
            "../../../components/javascript/zcat-components/testing-comp"
        ).then(function(res) {
            TestingComp = res.TestingComp;
        }));

        
;
    }
}

export {Test};

